var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 1,
    id: "_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M357.51,322H301.75a15,15,0,0,1,0-30h55.76a70.13,70.13,0,0,0,0-140.25c-1.89,0-3.9.09-6.14.29a15,15,0,0,1-14.25-7.42,98.17,98.17,0,0,0-181.68,32.6,15,15,0,0,1-15.35,12.47l-1.06,0A51.17,51.17,0,1,0,139,292h74.71a15,15,0,0,1,0,30H139a81.18,81.18,0,0,1-10.56-161.66,128.17,128.17,0,0,1,229.67-38.59A100.13,100.13,0,0,1,357.51,322Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M305.92,266.12a14.94,14.94,0,0,1-10.6-4.4l-37.58-37.57-37.57,37.57A15,15,0,0,1,199,240.51l48.18-48.18a15,15,0,0,1,21.21,0l48.18,48.18a15,15,0,0,1-10.61,25.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M257.74,382.69a15,15,0,0,1-15-15V202.94a15,15,0,0,1,30,0V367.69A15,15,0,0,1,257.74,382.69Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.05a88c1c6e3c0731968417f2ac4f9fe9.svg";
export { ForwardRef as ReactComponent };